import { connect } from 'react-redux';
import ProductBundle from '../../components/covid/components/ProductBundle';
import { FptiHelper } from '../../lib/fptiHelper';
import { get } from 'lodash';

const mapStateToProps = state => {
  const { app = {}, experimentation = {} } = state,
    defaultFptiOptions = {
      pgrp: 'main:merchanthub:productbundle:main',
      page: 'main:merchanthub:productbundle:main',
      flow: 'COVID_PRODUCT_BUNDLES'
    };
  let fptiHelper = new FptiHelper({ app, experimentation, defaultFptiOptions });

  return {
    app,
    fptiHelper,
    experimentation,
    productcompletion: get(state, 'productcompletion', {})
  };
};

export default connect(mapStateToProps)(ProductBundle);
